import styles from "./Select.module.scss";
import { forwardRef } from "react";
import { isEmpty } from "../util/validator";
const Select = forwardRef(function Select(props,ref) {
 
  const {label, placeHolder, id, values, simpleValues, error,clearError, setError, mandatory, ...otherProps} =props;
 const simpleOption= simpleValues?simpleValues.map(v=>( <option value={v}>{v}</option>)):'';
 const objectOption=values?values.map(v=>( <option value={v.Id}>{v.Name}</option>)):'';
 
 function changeHandler(event) {
  if (mandatory === true)
    !isEmpty(event.target.value) ? clearError(id) : setError(id);
}
  return (
    <>
      <div className={styles.formGroup}>
        <label htmlFor={id}>{label}</label>
        {mandatory&& <label className={styles.mandatory}>*</label>}
        <select id={id} {...otherProps} ref={ref} defaultValue="-1" onChange={changeHandler}>
          <option value="-1" disabled >{placeHolder}</option>
          {values===undefined?simpleOption :objectOption}
  
          </select>
        <div className="error">{error && <p>{error}</p>}</div>
      </div>
    </>
  );
});

export default Select;




